import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { closeMenu } from "../utils/appSlice";
import Comments from "./Comments";
import { GET_COMMENTS_URL, RELATED_VIDEOS_URL } from "../utils/contants";
import SuscribeContainer from "./SuscribeContainer";
import RelatedVideos from "./RelatedVideos";
// import { YOUTUBE_VIDEO_API } from "../utils/contants";
const WatchPage = () => {
  const [searchParams] = useSearchParams();
  const videoID = searchParams.get("v");
  const [commentsData, setData] = useState([]);
  const [relatedVideos, setRelatedVideos] = useState([]);
  
  const dispatch = useDispatch();

  const getComment = async () => {
    const data = await fetch(GET_COMMENTS_URL + videoID);
    const json = await data.json();
    setData(json.items);
  };

  const getRelatedVideos = async () => {
    const data = await fetch(RELATED_VIDEOS_URL + videoID);
    const json = await data.json();
    setRelatedVideos(json.items);
  };
  useEffect(() => {
    getComment();
    getRelatedVideos();
    dispatch(closeMenu());
  }, []);

  console.log(relatedVideos);
  return (
    <>
      <div className="flex flex-col">
        <div className="px-5">
          <iframe
            width="1000"
            height="500"
            src={"https://www.youtube.com/embed/" + searchParams.get("v")}
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
        {/* <Comments data={commentsData} key={videoID} /> */}
      </div>
      <div>
        {/* <RelatedVideos data={ relatedVideos} />  */}
      </div>
    </>
  );
};

export default WatchPage;
